const theme = {
  colors: {
    primary: '#0A6EBD',
    primaryDark: '#0859A0',
    primaryLight: '#1E7DD1',
    secondary: '#0A6EBD',
    secondaryDark: '#0859A0',
    secondaryLight: '#1E7DD1',
    purple: '#0A6EBD',
    purpleDark: '#0859A0',
    orange: '#F59E0B',
    orangeDark: '#D97706',
    coral: '#1E7DD1',
    coralDark: '#0859A0',
    background: '#F8FAFB',
    surface: '#FFFFFF',
    surfaceVariant: '#F0F9FF',
    textPrimary: '#1A2332',
    textSecondary: '#6B7280',
    textTertiary: '#9CA3AF',
    textInverse: '#FFFFFF',
    success: '#10B981',
    successLight: '#D1FAE5',
    successDark: '#065F46',
    warning: '#F59E0B',
    warningLight: '#FEF3C7',
    warningDark: '#92400E',
    error: '#DC2626',
    errorLight: '#FEE2E2',
    errorDark: '#991B1B',
    info: '#3B82F6',
    infoLight: '#DBEAFE',
    infoDark: '#1E40AF',
    border: '#E5E7EB',
    borderLight: '#F0F0F0',
    borderDark: '#D1D5DB',
  },
  gradients: {
    primary: ['#0A6EBD', '#0859A0'],
    secondary: ['#0A6EBD', '#0859A0'],
    purple: ['#0A6EBD', '#0859A0'],
    orange: ['#F59E0B', '#D97706'],
  },
  spacing: {
    xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 24, xxxl: 32, huge: 40,
  },
  borderRadius: {
    none: 0, xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 24, round: 1000,
  },
  shadows: {
    none: '0 0 0 rgba(0, 0, 0, 0)',
    sm: '0 2px 4px rgba(0, 0, 0, 0.08)',
    md: '0 4px 8px rgba(0, 0, 0, 0.12)',
    lg: '0 6px 12px rgba(0, 0, 0, 0.15)',
    xl: '0 8px 16px rgba(0, 0, 0, 0.2)',
  },
  antd: {
    components: {
      Menu: { itemSelectedBg: "#F0F9FF", itemSelectedColor: "#0A6EBD" },
      Table: { headerBg: "#F8FAFB", headerColor: "#475569", rowHoverBg: "#F7FBFF", borderColor: "#EEF2F6", cellPaddingBlock: 16, cellPaddingInline: 16, headerSplitColor: "transparent" },
      // A slimmer, rounder track; antd positions the label and handle from these.
      Switch: { trackHeight: 24, trackMinWidth: 44, handleSize: 20, trackPadding: 2, innerMinMargin: 8, innerMaxMargin: 26 },
    },
    token: {
      colorPrimary: '#0A6EBD',
      colorSuccess: '#10B981',
      colorWarning: '#F59E0B',
      colorError: '#DC2626',
      colorInfo: '#3B82F6',
      colorTextBase: '#1A2332',
      colorBgBase: '#FFFFFF',
      fontSize: 15,
      borderRadius: 12,
      controlHeight: 42,
      fontFamily: "'DM Sans', -apple-system, sans-serif",
      colorText: '#1A2332',
      colorTextSecondary: '#6B7280',
      colorBorder: '#E5E7EB',
    },
  },
};

export default theme;
